import {useRef} from 'react';

import {PageTransition} from '@/navigation/PageTransition';
import useDeepLinkCard from './hooks/useDeepLinkCard';
import {useInitialCardNavigation} from './hooks/useInitialCardNavigation';
import useTipsGuideContent from './hooks/useTipsGuideContent';
import {TipsListScrollProvider} from './hooks/useTipsListScrollRestore';
import useTipsNavigation from './hooks/useTipsNavigation';

const TipsAndTutorialsPage = () => {
    const {cards} = useTipsGuideContent();
    const listViewportRef = useRef<HTMLDivElement | null>(null);
    const listScrollTopRef = useRef(0);

    const deepLinkCard = useDeepLinkCard(cards);

    const {handleCardSelect, transitionProps} = useTipsNavigation({
        cards,
        deepLinkCard,
        listViewportRef,
        listScrollTopRef,
    });

    // Embedded deep-links open as the root view (handled inside useTipsNavigation); standalone
    // deep-links (e.g. Wi-Fi guide) still open the list first and animate to the card.
    useInitialCardNavigation(handleCardSelect, Boolean(deepLinkCard));

    return (
        <TipsListScrollProvider viewportRef={listViewportRef} scrollTopRef={listScrollTopRef}>
            <PageTransition {...transitionProps} />
        </TipsListScrollProvider>
    );
};

export default TipsAndTutorialsPage;
